import React from "react";
import { Globe } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { languages } from "@/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ variant = "ghost", testId = "language-switcher-trigger" }) {
  const { lang, changeLanguage } = useAuth();
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testId}
          className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-white px-3 py-1.5 text-sm font-medium text-brand-anthracite transition-colors hover:bg-brand-sand"
        >
          <Globe className="h-4 w-4 text-brand-taupe" />
          <span className="hidden sm:inline">{current.label}</span>
          <span className="sm:hidden uppercase">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white border-brand-line">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => changeLanguage(l.code)}
            className={`cursor-pointer ${l.code === lang ? "font-semibold text-brand-anthracite" : ""}`}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
